// extracted by mini-css-extract-plugin
module.exports = {"box":"FJAddButton_box__1xoOt","add_btn":"FJAddButton_add_btn__3pNG-","add_success_btn":"FJAddButton_add_success_btn__3oJT-"};